import { JwtService } from 'api';
import {
  clearOtpVerified,
  clearStoredAuthTokens,
  getStoredRefreshToken,
  setStoredAccessToken,
} from './authStorage';

let refreshInFlight: Promise<string | null> | null = null;

const executeTokenRefresh = async (): Promise<string | null> => {
  const refresh = getStoredRefreshToken();

  if (!refresh) {
    clearOtpVerified();
    clearStoredAuthTokens();
    return null;
  }

  try {
    const response = await JwtService.authJwtRefreshCreate({ refresh });

    if (response?.access) {
      setStoredAccessToken(response.access);
      return response.access;
    }

    clearOtpVerified();
    clearStoredAuthTokens();
    return null;
  } catch {
    clearOtpVerified();
    clearStoredAuthTokens();
    return null;
  }
};

/**
 * Issues at most one /auth/jwt/refresh request at a time.
 * Concurrent callers share the in-flight promise and receive the same result.
 * Returns the new access token string on success, or null when the session is unrecoverable.
 * On failure the stored tokens are always cleared before returning null.
 */
export const singleFlightTokenRefresh = (): Promise<string | null> => {
  if (refreshInFlight) {
    return refreshInFlight;
  }

  refreshInFlight = executeTokenRefresh().finally(() => {
    refreshInFlight = null;
  });

  return refreshInFlight;
};
